import React from 'react';

import _ from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';

import WithUser from 'shared/HOCs/WithUser';

import { trackImpression } from './ducks';

class DetailTracker extends React.Component {
  // this component calls create-{type}-detail-impression API once mounted
  componentDidMount() {
    const { user, slug, type, trackImpression } = this.props;

    if (user) {
      trackImpression({ slug, type });
    }
  }

  componentDidUpdate(prevProps) {
    // here we handle the case when a user is already on a page and then logs in
    const { user, slug, type, trackImpression } = this.props;

    if (_.isNil(prevProps.user) && user) {
      trackImpression({ slug, type });
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = { trackImpression };

export default compose(
  WithUser,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DetailTracker);
